import { gql } from '@apollo/client'
import bundledTicketsEventType from '~/graphql/fragments/bundledTickets'
import eventSeatingOptions from '~/graphql/fragments/eventSeatingOptions'

const eventTypeListing = gql`
  fragment eventTypeListing on EventType {
    id
    slug
    title
    startDate
    endDate
    isExpired
    ticketAlertsCount
    availableTicketsCount
    bundledTickets {
      ...bundledTicketsEventType
    }
    seatingOptions {
      ...eventSeatingOptions
    }
  }

  ${bundledTicketsEventType}
  ${eventSeatingOptions}
`

export default eventTypeListing
